// extracted by mini-css-extract-plugin
module.exports = {"commonWrapper":"SimpleStub__commonWrapper___2NNuR","textWrapper":"SimpleStub__textWrapper___13fRD"};